// extracted by mini-css-extract-plugin
export default {"intro3":"QFGUIwRfH6PpNcvAhxdl","btn":"idvuRY9fB03J7tXKf3Ad","right":"wmbg911j3xpZxS2NhV5w","products":"OqD0zMvpeFVzw2t1CVOq"};